import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import UIAlert from 'UIComponents/alert/UIAlert';
import { getDraftBriefByContact } from './utils/api/QualifiedLeadsApi';
import { jsx as _jsx } from "react/jsx-runtime";
function renderAlert(message, type = 'warning') {
  return /*#__PURE__*/_jsx("div", {
    className: "m-bottom-4",
    children: /*#__PURE__*/_jsx(UIAlert, {
      className: "p-all-3",
      type: type,
      use: "inline",
      children: message
    })
  });
}
function QualifiedLeadUnsubmittableStatus(props) {
  const [brief, setBrief] = useState(null);
  const fetchBrief = contactVid => {
    getDraftBriefByContact(contactVid).then(
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JSON' is not assignable to param... Remove this comment to see the full error message
    result => setBrief(result), __ => setBrief(null)).catch(console.log);
  };
  useEffect(() => fetchBrief(props.contactVid), [props.contactVid]);
  useEffect(() => {
    const handleWindowEvents = event => {
      if (event.origin !== window.location.origin) {
        return;
      }
      const {
        data
      } = event;
      if (!data.payload || `${data.payload.leadContactVid}` !== `${props.contactVid}`) {
        return;
      }
      switch (data.type) {
        case 'QL_PANEL_META_LOADED':
          fetchBrief(props.contactVid);
          break;
        default:
          break;
      }
    };
    window.addEventListener('message', handleWindowEvents, false);
    return () => {
      window.removeEventListener('message', handleWindowEvents);
    };
  }, [props.contactVid]);
  if (brief === null) {
    return null;
  }
  if (brief.isBlacklisted) {
    return renderAlert('Blacklisted domain');
  } else if (brief.isEmbargoed) {
    return renderAlert('Embargoed country');
  } else if (brief.isBadFit) {
    return renderAlert('Marked as Bad Fit');
  } else if (brief.isColdSourced) {
    return renderAlert('Cold Sourced domain');
  } else if (brief.isDisputed) {
    return renderAlert('Open dispute');
  } else if (brief.isQuarantined) {
    return renderAlert('Quarantined', 'info');
  } else if (brief.isOpen) {
    return renderAlert('Open owner', 'info');
  } else {
    return null;
  }
}
QualifiedLeadUnsubmittableStatus.propTypes = {
  contactVid: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};
export default QualifiedLeadUnsubmittableStatus;